// import React, { useState, useEffect } from "react";
// import "../../Landing.css";
// import "./ItemPathFilter.css";
// import { useSelector } from "react-redux";

// const MenuItem = ({ item, searchTerm, path }) => {
//   const itemName = item.name.toLowerCase();
//   const searchTermLower = searchTerm.toLowerCase();
//   const isMatch = itemName.includes(searchTermLower);

//   const currentPath = path ? `${path} > ${item.name}` : item.name;

//   if (!isMatch && (!item.children || item.children.length === 0)) {
//     return null;
//   }

//   return (
//     <div className="menu-item">
//       {isMatch && (
//         <div className="menu-item-content">
//           <div>
//             <strong>{item.children?"":item.name}</strong>
//           </div>
//           <div>{item.children?"":currentPath}</div>
//         </div>
//       )}
//       {item.children && (
//         <div className="submenu">
//           {item.children.map((child, index) => (
//             <MenuItem
//               key={index}
//               item={child}
//               searchTerm={searchTerm}
//               path={currentPath}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const Menu = ({ data, searchTerm }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-container">
//       {data.map((menuItem, index) => (
//         <MenuItem key={index} item={menuItem} searchTerm={searchTerm} path="" />
//       ))}
//     </div>
//   );
// };

// const SearchBar = ({ setSearchTerm, toggleDropdown }) => {
//   const handleChange = (value) => {
//     setSearchTerm(value);
//     toggleDropdown(true);
//   };

//   return (
//     <div className="input_wrapper">
//       <input
//         className="filter_input"
//         placeholder="Search..."
//         onChange={(e) => handleChange(e.target.value)}
//         onFocus={() => toggleDropdown(true)}
//       ></input>
//       <p className="filter_icon"></p>
//     </div>
//   );
// };

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     if (!menuMap[menuItem.LVL1]) {
//       menuMap[menuItem.LVL1] = {
//         name: menuItem.LVL1,
//         colors: "#ecf0f1",
//         children: [],
//       };
//       menuStructure.push(menuMap[menuItem.LVL1]);
//     }

//     let level2 = menuMap[menuItem.LVL1].children.find(
//       (c) => c.name === menuItem.LVL2
//     );
//     if (!level2) {
//       level2 = {
//         name: menuItem.LVL2,
//         colors: "#bdc3c7",
//         children: [],
//       };
//       menuMap[menuItem.LVL1].children.push(level2);
//     }

//     let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//     if (!level3) {
//       level3 = {
//         name: menuItem.LVL3,
//         colors: "#95a5a6",
//       };
//       level2.children.push(level3);
//     }

//     if (menuItem.ui_path && menuItem.ui_element) {
//       const routeExists = localRoutes.some(
//         (route) =>
//           route.ui_path === menuItem.ui_path &&
//           route.ui_element === menuItem.ui_element
//       );
//       if (!routeExists) {
//         localRoutes.push({
//           ui_path: menuItem.ui_path,
//           ui_element: menuItem.ui_element,
//         });
//       }
//       level3.ui_path = menuItem.ui_path;
//       level3.ui_element = menuItem.ui_element;
//     }
//   });

//   return { menuStructure, localRoutes };
// };

// const getLeafNodesWithPath = (menuStructure) => {
//   const leafNodes = [];

//   const traverse = (node, path) => {
//     if (!node.children || node.children.length === 0) {
//       if (node.ui_path && node.ui_element) {
//         leafNodes.push({
//           name: node.name,
//           ui_path: node.ui_path,
//           ui_element: node.ui_element,
//           path: `${path} > ${node.name}`,
//         });
//       }
//       return;
//     }

//     const currentPath = path ? `${path} > ${node.name}` : node.name;
//     node.children.forEach((child) => traverse(child, currentPath));
//   };

//   menuStructure.forEach((item) => traverse(item, ""));
//   return leafNodes;
// };

// function ItemPathFilter() {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);
//   let menuDatas = data && data.client_schema_name?.[2];

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   const { menuStructure } = getMenuStructureWithColors(menuData);

//   const leafNodes = getLeafNodesWithPath(menuStructure);
//   // console.log(JSON.stringify(leafNodes, null, 2));
//   console.log(leafNodes);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);

//   return (
//     <div className="item-path-filter">
//       <SearchBar setSearchTerm={setSearchTerm} toggleDropdown={setShowDropdown} />
//       {showDropdown && (
//         <div className="ipf-dropdown-menu">
//           <Menu searchTerm={searchTerm} data={menuStructure} />
//         </div>
//       )}
//     </div>
//   );
// }

// export default ItemPathFilter;

// ===============================================================================


























// import React, { useState, useEffect } from "react";
// import "../../Landing.css";
// import "./ItemPathFilter.css";
// import { useSelector } from "react-redux";

// import { Link } from "react-router-dom";

// const MenuItem = ({ item, searchTerm }) => {
//   const itemName = item.name.toLowerCase();
//   const searchTermLower = searchTerm.toLowerCase();
//   const isMatch = itemName.includes(searchTermLower);

//   if (!isMatch) {
//     return null;
//   }

//   return (
//     <div className="menu-item">
//       <div className="menu-item-content">
//         <Link to={item.ui_path} style={{color: "black"}}>
//           <div>
//             <strong>{item.name}</strong>
//           </div>
//           <div className="menu-item-path">{item.path}</div>
//         </Link>
//       </div>
//     </div>
//   );
// };

// const Menu = ({ data, searchTerm }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-container">
//       {data
//         .filter((item) =>
//           item.name.toLowerCase().includes(searchTerm.toLowerCase())
//         )
//         .map((menuItem, index) => (
//           <MenuItem key={index} item={menuItem} searchTerm={searchTerm} />
//         ))}
//     </div>
//   );
// };

// const SearchBar = ({ setSearchTerm, toggleDropdown }) => {
//   const handleChange = (value) => {
//     setSearchTerm(value);
//     toggleDropdown(true);
//   };

//   return (
//     <div className="input_wrapper">
//       <input
//         className="filter_input"
//         placeholder="Search..."
//         onChange={(e) => handleChange(e.target.value)}
//         onFocus={() => toggleDropdown(true)}
//       ></input>
//       <p className="filter_icon"></p>
//     </div>
//   );
// };

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     if (!menuMap[menuItem.LVL1]) {
//       menuMap[menuItem.LVL1] = {
//         name: menuItem.LVL1,
//         colors: "#ecf0f1",
//         children: [],
//       };
//       menuStructure.push(menuMap[menuItem.LVL1]);
//     }

//     let level2 = menuMap[menuItem.LVL1].children.find(
//       (c) => c.name === menuItem.LVL2
//     );
//     if (!level2) {
//       level2 = {
//         name: menuItem.LVL2,
//         colors: "#bdc3c7",
//         children: [],
//       };
//       menuMap[menuItem.LVL1].children.push(level2);
//     }

//     let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//     if (!level3) {
//       level3 = {
//         name: menuItem.LVL3,
//         colors: "#95a5a6",
//       };
//       level2.children.push(level3);
//     }

//     if (menuItem.ui_path && menuItem.ui_element) {
//       const routeExists = localRoutes.some(
//         (route) =>
//           route.ui_path === menuItem.ui_path &&
//           route.ui_element === menuItem.ui_element
//       );
//       if (!routeExists) {
//         localRoutes.push({
//           ui_path: menuItem.ui_path,
//           ui_element: menuItem.ui_element,
//         });
//       }
//       level3.ui_path = menuItem.ui_path;
//       level3.ui_element = menuItem.ui_element;
//     }
//   });

//   return { menuStructure, localRoutes };
// };

// const getLeafNodesWithPath = (menuStructure) => {
//   const leafNodes = [];

//   const traverse = (node, path) => {
//     if (!node.children || node.children.length === 0) {
//       if (node.ui_path && node.ui_element) {
//         leafNodes.push({
//           name: node.name,
//           ui_path: node.ui_path,
//           ui_element: node.ui_element,
//           path: `${path} > ${node.name}`,
//         });
//       }
//       return;
//     }

//     const currentPath = path ? `${path} > ${node.name}` : node.name;
//     node.children.forEach((child) => traverse(child, currentPath));
//   };

//   menuStructure.forEach((item) => traverse(item, ""));
//   return leafNodes;
// };

// function ItemPathFilter() {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);
//   let menuDatas = data && data.client_schema_name?.[2];

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   const leafNodes = getLeafNodesWithPath(menuStructure);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);

//   return (
//     <div className="item-path-filter">
//       <SearchBar
//         setSearchTerm={setSearchTerm}
//         toggleDropdown={setShowDropdown}
//       />
//       {showDropdown && (
//         <div className="ipf-dropdown-menu">
//           <Menu searchTerm={searchTerm} data={leafNodes} />
//         </div>
//       )}
//     </div>
//   );
// }

// export default ItemPathFilter;


















// =====================================================













// import React, { useState, useEffect, useRef } from "react";
// import "../../Landing.css";
// import "./ItemPathFilter.css";
// import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";

// const MenuItem = ({ item, searchTerm, onClick, setPagePath }) => {
//   const itemName = item.name.toLowerCase();
//   const searchTermLower = searchTerm.toLowerCase();
//   const isMatch = itemName.includes(searchTermLower);

//   if (!isMatch) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-item" onClick={onClick}>
//       <div className="menu-item-content">
//         <Link to={item.ui_path} style={{ color: "black" }} onClick={()=>{setPagePath(item.path)}}>
//           <div>
//             <strong className="ipf-itemfilter">{item.name}</strong>
//           </div>
//           <div className="ipf-menu-item-path">{item.path}</div>
//         </Link>
//       </div>
//     </div>
//   );
// };

// const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-container">
//       {data
//         .filter((item) =>
//           item.name.toLowerCase().includes(searchTerm.toLowerCase())
//         )
//         .map((menuItem, index) => (
//           <MenuItem
//             key={index}
//             item={menuItem}
//             searchTerm={searchTerm}
//             onClick={onItemClick}
//             setPagePath={setPagePath}
//           />
//         ))}
//     </div>
//   );
// };

// const SearchBar = ({ setSearchTerm, toggleDropdown }) => {
//   const handleChange = (value) => {
//     setSearchTerm(value);
//     toggleDropdown(true);
//   };

//   return (
//     <div className="input_wrapper">
//       <input
//       style={{marginLeft:""}}
//         className="filter_input"
//         placeholder="Search..."
//         onChange={(e) => handleChange(e.target.value)}
//         onFocus={() => toggleDropdown(true)}
//       ></input>
//       <p className="filter_icon"></p>
//     </div>
//   );
// };

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     if (!menuMap[menuItem.LVL1]) {
//       menuMap[menuItem.LVL1] = {
//         name: menuItem.LVL1,
//         colors: "#ecf0f1",
//         children: [],
//       };
//       menuStructure.push(menuMap[menuItem.LVL1]);
//     }

//     let level2 = menuMap[menuItem.LVL1].children.find(
//       (c) => c.name === menuItem.LVL2
//     );
//     if (!level2) {
//       level2 = {
//         name: menuItem.LVL2,
//         colors: "#bdc3c7",
//         children: [],
//       };
//       menuMap[menuItem.LVL1].children.push(level2);
//     }

//     let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//     if (!level3) {
//       level3 = {
//         name: menuItem.LVL3,
//         colors: "#95a5a6",
//       };
//       level2.children.push(level3);
//     }

//     if (menuItem.ui_path && menuItem.ui_element) {
//       const routeExists = localRoutes.some(
//         (route) =>
//           route.ui_path === menuItem.ui_path &&
//           route.ui_element === menuItem.ui_element
//       );
//       if (!routeExists) {
//         localRoutes.push({
//           ui_path: menuItem.ui_path,
//           ui_element: menuItem.ui_element,
//         });
//       }
//       level3.ui_path = menuItem.ui_path;
//       level3.ui_element = menuItem.ui_element;
//     }
//   });

//   return { menuStructure, localRoutes };
// };

// const getLeafNodesWithPath = (menuStructure) => {
//   const leafNodes = [];

//   const traverse = (node, path) => {
//     if (!node.children || node.children.length === 0) {
//       if (node.ui_path && node.ui_element) {
//         leafNodes.push({
//           name: node.name,
//           ui_path: node.ui_path,
//           ui_element: node.ui_element,
//           path: `${path} > ${node.name}`,
//         });
//       }
//       return;
//     }

//     const currentPath = path ? `${path} > ${node.name}` : node.name;
//     node.children.forEach((child) => traverse(child, currentPath));
//   };

//   menuStructure.forEach((item) => traverse(item, ""));
//   return leafNodes;
// };

// function ItemPathFilter(setPagePath) {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);
//   let menuDatas = data && data.client_schema_name?.[2];

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   const leafNodes = getLeafNodesWithPath(menuStructure);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [showDropdown, setShowDropdown] = useState(false);
//   const dropdownRef = useRef(null);

//   const handleClickOutside = (event) => {
//     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//       setShowDropdown(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleItemClick = () => {
//     setShowDropdown(false);
//   };

//   return (
//     <div className="item-path-filter" ref={dropdownRef}>
//       <SearchBar
//         setSearchTerm={setSearchTerm}
//         toggleDropdown={setShowDropdown}
//       />
//       {showDropdown && (
//         <div className="ipf-dropdown-menu">
//           <Menu searchTerm={searchTerm} data={leafNodes} onItemClick={handleItemClick} setPagePath={setPagePath}/>
//         </div>
//       )}
//     </div>
//   );
// }

// export default ItemPathFilter;























import React, { useState, useEffect, useRef } from "react";
import "../../Landing.css";
import "./ItemPathFilter.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GoldenSearch from "../../../../Assets/Images/CommanImages/golden-filter.png";
import LinkIcon from "./../../../../Assets/Images/CommanImages/Vector.png";
const MenuItem = ({ item, searchTerm, onClick, setPagePath }) => {
  const itemName = item.name.toLowerCase();
  const searchTermLower = searchTerm.toLowerCase();
  const isMatch = itemName.includes(searchTermLower);

  if (!isMatch) {
    return null;
  }

  return (
    <div className="ipf-menu-item" onClick={onClick}>
      <div className="menu-item-content">
        <Link to={item.ui_path} style={{ color: "black" }} onClick={() => setPagePath(item.path)}>
          <div>
            <img className="ipf-itemimage" src={LinkIcon} alt="" />
            <strong className="ipf-itemfilter">{item.name}</strong>
          </div>
          <div className="ipf-menu-item-path">{item.path}</div>
        </Link>
      </div>
    </div>
  );
};

// const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
//   if (!searchTerm) {
//     return null;
//   }

//   return (
//     <div className="ipf-menu-container">
//       {data
//         .filter((item) =>
//           item.name.toLowerCase().includes(searchTerm.toLowerCase())
//         )
//         .map((menuItem, index) => (
//           <MenuItem
//             key={index}
//             item={menuItem}
//             searchTerm={searchTerm}
//             onClick={onItemClick}
//             setPagePath={setPagePath}
//           />
//         ))}
//     </div>
//   );
// };

const Menu = ({ data, searchTerm, onItemClick, setPagePath }) => {
  if (!searchTerm) {
    return null;
  }

  const filteredItems = data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (filteredItems.length === 0) {
    return (
      <div className="ipf-menu-container">
        <div className="no-results">No results found</div>
      </div>
    );
  }

  return (
    <div className="ipf-menu-container">
      {filteredItems.map((menuItem, index) => (
        <MenuItem
          key={index}
          item={menuItem}
          searchTerm={searchTerm}
          onClick={onItemClick}
          setPagePath={setPagePath}
        />
      ))}
    </div>
  );
};


const SearchBar = ({ setSearchTerm, toggleDropdown }) => {
  const handleChange = (value) => {
    setSearchTerm(value);
    toggleDropdown(true);
  };

  return (
    // <div className="input_wrapper">
    //   <input
    //     className="filter_input-LeftMenu"
    //     placeholder="Filter Menu"
    //     onChange={(e) => handleChange(e.target.value)}
    //     onFocus={() => toggleDropdown(true)}
    //     style={{paddingLeft:"50px", fontWeight:"600", fontStyle:"italic"}}
    //   />
    //   {/* <p className="filter_icon"></p> */}
    //   <img src={GoldenSearch} className="golden-filter" alt="" />
    // </div>
     <div className="input_wrapper" style={{ position: "relative", display: "flex", alignItems: "center" }}>
        <input
          className="filter_input-LeftMenu"
          placeholder="Filter Menu"
          onChange={(e) => handleChange(e.target.value)}
          onFocus={() => toggleDropdown(true)}
          style={{ paddingLeft: "50px", fontWeight: "600", fontStyle: "italic" }}
        />
        <img
          src={GoldenSearch}
          className="golden-filter"
          alt=""
          style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)", width: "20px", height: "20px", pointerEvents: "none" }}
        />
    </div>
  );
};

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     if (!menuMap[menuItem.LVL1]) {
//       menuMap[menuItem.LVL1] = {
//         name: menuItem.LVL1,
//         colors: "#ecf0f1",
//         children: [],
//       };
//       menuStructure.push(menuMap[menuItem.LVL1]);
//     }

//     let level2 = menuMap[menuItem.LVL1].children.find(
//       (c) => c.name === menuItem.LVL2
//     );
//     if (!level2) {
//       level2 = {
//         name: menuItem.LVL2,
//         colors: "#bdc3c7",
//         children: [],
//       };
//       menuMap[menuItem.LVL1].children.push(level2);
//     }

//     let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//     if (!level3) {
//       level3 = {
//         name: menuItem.LVL3,
//         colors: "#95a5a6",
//       };
//       level2.children.push(level3);
//     }

//     if (menuItem.ui_path && menuItem.ui_element) {
//       const routeExists = localRoutes.some(
//         (route) =>
//           route.ui_path === menuItem.ui_path &&
//           route.ui_element === menuItem.ui_element
//       );
//       if (!routeExists) {
//         localRoutes.push({
//           ui_path: menuItem.ui_path,
//           ui_element: menuItem.ui_element,
//         });
//       }
//       level3.ui_path = menuItem.ui_path;
//       level3.ui_element = menuItem.ui_element;
//     }
//   });

//   return { menuStructure, localRoutes };
// };

const getMenuStructureWithColors = (data) => {
  const menuMap = {};
  const menuStructure = [];
  let localRoutes = [];

  data.forEach((menuItem) => {
    if (!menuMap[menuItem.LVL1]) {
      menuMap[menuItem.LVL1] = {
        name: menuItem.LVL1,
        colors: "#ecf0f1",
        children: [],
      };
      menuStructure.push(menuMap[menuItem.LVL1]);
    }

    let level2 = menuMap[menuItem.LVL1].children.find(
      (c) => c.name === menuItem.LVL2
    );
    if (!level2) {
      level2 = {
        name: menuItem.LVL2,
        colors: "#bdc3c7",
        children: [],
      };
      menuMap[menuItem.LVL1].children.push(level2);
    }

    // ✅ FIX: LVL3 empty/null ho toh ui_path level2 pe set karo
    if (!menuItem.LVL3) {
      if (menuItem.ui_path && menuItem.ui_element) {
        level2.ui_path = menuItem.ui_path;
        level2.ui_element = menuItem.ui_element;

        const routeExists = localRoutes.some(
          (route) =>
            route.ui_path === menuItem.ui_path &&
            route.ui_element === menuItem.ui_element
        );
        if (!routeExists) {
          localRoutes.push({
            ui_path: menuItem.ui_path,
            ui_element: menuItem.ui_element,
          });
        }
      }
      return; // level3 node mat banao
    }

    let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
    if (!level3) {
      level3 = {
        name: menuItem.LVL3,
        colors: "#95a5a6",
        children: [],
      };
      level2.children.push(level3);
    }

    if (menuItem.ui_path && menuItem.ui_element) {
      const routeExists = localRoutes.some(
        (route) =>
          route.ui_path === menuItem.ui_path &&
          route.ui_element === menuItem.ui_element
      );
      if (!routeExists) {
        localRoutes.push({
          ui_path: menuItem.ui_path,
          ui_element: menuItem.ui_element,
        });
      }
      level3.ui_path = menuItem.ui_path;
      level3.ui_element = menuItem.ui_element;
    }
  });

  return { menuStructure, localRoutes };
};

// const getLeafNodesWithPath = (menuStructure) => {
//   const leafNodes = [];

//   const traverse = (node, path) => {
//     if (!node.children || node.children.length === 0) {
//       if (node.ui_path && node.ui_element) {
//         leafNodes.push({
//           name: node.name,
//           ui_path: node.ui_path,
//           ui_element: node.ui_element,
//           path: `${path} > ${node.name}`,
//         });
//       }
//       return;
//     }

//     const currentPath = path ? `${path} > ${node.name}` : node.name;
//     node.children.forEach((child) => traverse(child, currentPath));
//   };

//   menuStructure.forEach((item) => traverse(item, ""));
//   return leafNodes;
// };

const getLeafNodesWithPath = (menuStructure) => {
  const leafNodes = [];

  const traverse = (node, path) => {
    const currentPath = path ? `${path} > ${node.name}` : node.name;

    // ✅ FIX: node ke paas ui_path ho aur children empty ho — leaf node hai
    const hasNoChildren = !node.children || node.children.length === 0;
    
    if (hasNoChildren) {
      if (node.ui_path && node.ui_element) {
        leafNodes.push({
          name: node.name,
          ui_path: node.ui_path,
          ui_element: node.ui_element,
          path: currentPath,
        });
      }
      return;
    }

    // ✅ FIX: node ke paas children bhi hain aur khud bhi ui_path hai (LVL2 direct link case)
    if (node.ui_path && node.ui_element) {
      leafNodes.push({
        name: node.name,
        ui_path: node.ui_path,
        ui_element: node.ui_element,
        path: currentPath,
      });
    }

    node.children.forEach((child) => traverse(child, currentPath));
  };

  menuStructure.forEach((item) => traverse(item, ""));
  return leafNodes;
};


function ItemPathFilter({ setPagePath }) {
  const [menuData, setMenuData] = useState([]);
  const { data } = useSelector((state) => state.landing);
  let menuDatas = data && data.client_schema_name?.[2];

  useEffect(() => {
    if (menuDatas) {
      setMenuData(menuDatas);
    }
  }, [menuDatas]);

  const { menuStructure } = getMenuStructureWithColors(menuData);
  const leafNodes = getLeafNodesWithPath(menuStructure);

  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleItemClick = () => {
    setSearchTerm("");
    setShowDropdown(false);
  };

  return (
    <div className="item-path-filter" ref={dropdownRef}>
      <SearchBar
        setSearchTerm={setSearchTerm}
        toggleDropdown={setShowDropdown}
      />
      {showDropdown && (
        <div className="ipf-dropdown-menu">
          <Menu searchTerm={searchTerm} data={leafNodes} onItemClick={handleItemClick} setPagePath={setPagePath} />
        </div>
      )}
    </div>
  );
}

export default ItemPathFilter;

